export const WS_PATH = '/ws';
//# sourceMappingURL=events.js.map